export const mapCreateCustomerToApi = (customer: any) => {
    const {
        name,
        address,
        email,
        person_in_charge,
        contact,
        second_person_in_charge,
        second_customer_contact,
        phone,
        start_date,
        country,
        departament,
        municipaly,
        permissions,
        applications,
        has_trial,
        trial_ends_at,
        subscription_ends_at
    } = customer;

    return {
        name,
        address,
        email,
        person_in_charge,
        contact: contact ? contact.toString() : '',
        second_person_in_charge,
        second_customer_contact: second_customer_contact ? second_customer_contact.toString() : '',
        phone: phone ? phone.toString() : '',
        country: country?.value || '',
        departament: departament?.value || '',
        municipaly: municipaly?.value || '',
        start_date,
        type_plan: "65fbb619b866f185b9b201bf",
        applications: applications ? applications.map((app: any) => app.value) : [],
        permissions: [],
        trial_ends_at: has_trial ? trial_ends_at : null,
        subscription_ends_at: has_trial ? null : subscription_ends_at
    };
};

export const mapEditCustomerToApi = (customer: any) => {
    const {
        e_name,
        e_address,
        e_email,
        e_person_in_charge,
        e_contact,
        e_second_person_in_charge,
        e_second_customer_contact,
        e_phone,
        e_start_date,
        e_country,
        e_departament,
        e_municipaly,
        e_permissions,
        e_subscription_ends_at,
        customerId
    } = customer;

    return {
        name: e_name,
        address: e_address,
        email: e_email,
        person_in_charge: e_person_in_charge,
        contact: e_contact ? e_contact.toString() : '',
        second_person_in_charge: e_second_person_in_charge,
        second_customer_contact: e_second_customer_contact ? e_second_customer_contact.toString() : '',
        phone: e_phone ? e_phone.toString() : '',
        country: e_country?.value || '',
        departament: e_departament?.value || '',
        municipaly: e_municipaly?.value || '',
        start_date: e_start_date,
        type_plan: "65fbb619b866f185b9b201bf",
        permissions: e_permissions || [],
        subscription_ends_at: e_subscription_ends_at,
        customerId: customerId
    };
};
